<template>

  <div class="mod-planned-order">

    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">

      <el-form-item label="计划单号"><el-input v-model="q.plannedOrderCode" size="small" clearable /></el-form-item>

      <el-form-item label="物料编码"><el-input v-model="q.materialCode" size="small" clearable /></el-form-item>

      <el-form-item label="审核">

        <el-select v-model="q.approveStatus" size="small" clearable style="width:100px">

          <el-option label="草稿" value="0" /><el-option label="已审" value="2" />

        </el-select>

      </el-form-item>

      <el-form-item label="转单">

        <el-select v-model="q.convertStatus" size="small" clearable style="width:100px">

          <el-option label="未转" value="0" /><el-option label="已转" value="1" />

        </el-select>

      </el-form-item>

      <el-form-item>

        <el-button v-if="isAuth('production:plannedOrder:list')" type="primary" size="small" @click="search">查询</el-button>

        <el-button v-if="isAuth('production:plannedOrder:save')" type="primary" size="small" @click="open()">新增</el-button>

      </el-form-item>

    </el-form>

    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle">

      <el-table-column type="index" width="50" header-align="center" align="center" />

      <el-table-column prop="plannedOrderCode" label="计划单号" min-width="130" header-align="center" align="left">

        <template slot-scope="s"><span class="code-link" @click="open(s.row, true)">{{ s.row.plannedOrderCode }}</span></template>

      </el-table-column>

      <el-table-column prop="plannedDate" label="计划日期" width="110" header-align="center" align="center">

        <template slot-scope="s">{{ (s.row.plannedDate || '').slice(0, 10) }}</template>

      </el-table-column>

      <el-table-column prop="materialCode" label="物料编码" min-width="120" header-align="center" align="left" />

      <el-table-column prop="materialName" label="物料名称" min-width="130" header-align="center" align="left" />

      <el-table-column prop="quantity" label="数量" width="90" header-align="center" align="right" />

      <el-table-column prop="supplyType" label="建议方式" width="90" header-align="center" align="center">

        <template slot-scope="s">{{ supplyLabel(s.row.supplyType) }}</template>

      </el-table-column>

      <el-table-column label="转单目标" width="100" header-align="center" align="center">

        <template slot-scope="s">{{ s.row.convertStatus === '1' ? '已转' : (s.row.supplyType === 'make' ? '→工单' : '→采购') }}</template>

      </el-table-column>

      <el-table-column prop="approveStatus" label="审核" width="80" header-align="center" align="center">

        <template slot-scope="s">{{ s.row.approveStatus === '2' ? '已审' : '草稿' }}</template>

      </el-table-column>

      <el-table-column prop="convertStatus" label="转单" width="80" header-align="center" align="center">

        <template slot-scope="s">{{ s.row.convertStatus === '1' ? '已转' : '未转' }}</template>

      </el-table-column>

      <el-table-column label="操作" width="180" fixed="right" header-align="center" align="center">

        <template slot-scope="s">

          <el-button v-if="isAuth('production:plannedOrder:approve') && s.row.approveStatus !== '2'" type="text" size="small" @click="approve(s.row, true)">审核</el-button>

          <el-button v-if="isAuth('production:plannedOrder:unapprove') && s.row.approveStatus === '2' && s.row.convertStatus !== '1'" type="text" size="small" @click="approve(s.row, false)">弃审</el-button>

          <el-button v-if="isAuth('production:plannedOrder:convert') && s.row.approveStatus === '2' && s.row.convertStatus !== '1'" type="text" size="small" @click="convert(s.row)">转单</el-button>

          <el-button v-if="isAuth('production:plannedOrder:delete') && s.row.approveStatus !== '2' && s.row.convertStatus !== '1'" type="text" size="small" @click="remove(s.row)">删除</el-button>

        </template>

      </el-table-column>

    </el-table>

    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[20, 50, 100]" :page-size="pageSize" :total="total"

      layout="total, sizes, prev, pager, next" @size-change="s => { pageSize = s; pageIndex = 1 }" @current-change="p => { pageIndex = p }" />



    <planned-order-add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="load" />



    <el-dialog title="转单" :visible.sync="convertVisible" width="460px" append-to-body>

      <p>{{ convertHint }}</p>

      <el-checkbox v-if="convertMake" v-model="convertAutoRelease" style="margin-top:12px">本次转工单后自动下达</el-checkbox>

      <p v-if="convertMake" style="margin-top:8px;color:#909399;font-size:12px">未勾选时遵循系统参数 production-planned-auto-release。</p>

      <span slot="footer">

        <el-button @click="convertVisible = false">取消</el-button>

        <el-button type="primary" @click="doConvert">确定</el-button>

      </span>

    </el-dialog>

  </div>

</template>



<script>

import request from '../../api/request'

import { fetchPerms } from '../../api/auth'

import PlannedOrderAddOrUpdate from './plannedOrder-add-or-update.vue'



export default {

  name: 'PlannedOrder',

  components: { PlannedOrderAddOrUpdate },

  data() {

    return {

      q: { plannedOrderCode: '', materialCode: '', approveStatus: '', convertStatus: '' },

      convertVisible: false, convertRow: null, convertMake: false, convertAutoRelease: false, convertHint: '',

      list: [], pageIndex: 1, pageSize: 20, loading: false, addOrUpdateVisible: false, permCodes: [],

      headStyle: { background: '#f5f7fa', color: '#606266' }

    }

  },

  computed: {

    filtered() {

      return this.list.filter(row => {

        const material = (this.q.materialCode || '').trim()

        if (material && String(row.materialCode || '').indexOf(material) < 0) return false

        if (this.q.approveStatus && String(row.approveStatus) !== this.q.approveStatus) return false

        if (this.q.convertStatus && String(row.convertStatus) !== this.q.convertStatus) return false

        return true

      })

    },

    total() { return this.filtered.length },

    pageList() { return this.filtered.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize) }

  },

  created() { this.loadPerms(); this.load() },

  methods: {

    isAuth(perm) {

      const user = this.$store.state.user || {}

      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []

      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true

      return this.permCodes.indexOf(perm) >= 0

    },

    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },

    supplyLabel(t) { return { make: '自制', buy: '外购', subcontract: '委外' }[t] || t || '—' },

    search() { this.pageIndex = 1; this.load() },

    load() {

      this.loading = true

      request.get('/plan/plannedOrder/list', { params: { keyword: this.q.plannedOrderCode } }).then(res => {

        this.list = res.data || []

      }).catch(() => { this.list = [] }).finally(() => { this.loading = false })

    },

    open(rowOrId, readonly) {

      this.addOrUpdateVisible = true

      this.$nextTick(() => {

        const go = (row) => this.$refs.addOrUpdate && this.$refs.addOrUpdate.init(row || null, !!readonly)

        if (rowOrId == null || rowOrId === '') { go(null); return }

        const id = typeof rowOrId === 'object' ? rowOrId.plannedOrderId : rowOrId

        if (!id) { go(typeof rowOrId === 'object' ? rowOrId : null); return }

        request.get('/plan/plannedOrder/info', { params: { id: String(id) } }).then(res => {

          go(res.data || (typeof rowOrId === 'object' ? rowOrId : { plannedOrderId: String(id) }))

        }).catch(() => go(typeof rowOrId === 'object' ? rowOrId : { plannedOrderId: String(id) }))

      })

    },

    approve(row, yes) {

      const path = yes ? '/plan/plannedOrder/approve' : '/plan/plannedOrder/unapprove'

      request.post(path, { id: row.plannedOrderId }).then(() => { this.$message.success('操作成功'); this.load() }).catch(() => {})

    },

    remove(row) {

      this.$confirm('删除后，若该 MRP 批次下已无计划订单，批次会回到已运算，可再次生成。是否继续？', '提示', { type: 'warning' }).then(() => {

        request.post('/plan/plannedOrder/delete', { id: row.plannedOrderId }).then(() => { this.$message.success('已删除'); this.load() }).catch(() => {})

      }).catch(() => {})

    },

    convert(row) {

      this.convertRow = row

      this.convertMake = row.supplyType === 'make' || !row.supplyType

      this.convertAutoRelease = false

      this.convertHint = row.supplyType === 'subcontract'

        ? '将生成委外采购订单（草稿，需维护物料主供应商）。'

        : (this.convertMake ? '将生成生产工单。' : '将生成采购订单（草稿，需维护物料主供应商）。')

      this.convertVisible = true

    },

    doConvert() {

      const row = this.convertRow

      if (!row) return

      const body = { id: row.plannedOrderId }

      if (this.convertMake && this.convertAutoRelease) body.autoRelease = true

      request.post('/plan/plannedOrder/convert', body).then(res => {

        const released = res.data && res.data.released

        this.$message.success(released ? '转单成功，工单已下达' : '转单成功')

        this.convertVisible = false

        this.load()

      }).catch(() => {})

    }

  }

}

</script>



<style scoped>

.list-pagination { margin-top: 12px; text-align: right; }

.toolbar >>> .el-form-item { margin-bottom: 8px; }

.code-link { color: #348adb; cursor: pointer; }

</style>


